export default "__VITE_ASSET__QTwDR841__"